// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "chunks/" + chunkId + "." + {"1112":"8b99ee962f7e3a421917","2063":"6c5e389179871e1cd46a","6048":"1459a935ed20e2f01fdb"}[chunkId] + ".js";
};